module.exports = __webpack_public_path__ + "media/images/map_icons/Polo-aeb720341f04d1dfc933e5cbf88dbf07.svg";